export interface PbxSmsCampaignDetails {
  pbxHasACampaign: boolean
  pbxIsUsingSms: boolean
  pbxMayNeedACampaignToUseSms: boolean
  pbxNeedsACampaignToUseSms: boolean
  userIsAddOnAdmin: boolean
  pbxSmsActionRequired: boolean
  pbxHasSubIdWaitingCustomerAnswer: boolean
}

export const DEFAULT_PBX_SMS_CAMPAIGN_DETAILS: PbxSmsCampaignDetails = {
  pbxHasACampaign: false,
  pbxIsUsingSms: false,
  pbxMayNeedACampaignToUseSms: false,
  pbxNeedsACampaignToUseSms: false,
  userIsAddOnAdmin: false,
  pbxSmsActionRequired: false,
  pbxHasSubIdWaitingCustomerAnswer: false,
}
